module.exports = __webpack_public_path__ + "img/serbia.6288ffc8.svg";